export default __webpack_public_path__ + "static/invite_m-633e20b0b006764f3b28a84f8ea68853.png";